import styles from "./PopUp.module.css"

function PopUp({ children, grey, yellow, innerRef, className, ...props }) {
    return(
        <div
        ref={innerRef}
        className={[styles.popUp, grey && styles.grey, yellow && styles.yellow, className]
          .filter((e) => !!e)
          .join(" ")} {...props}
      >
        {children}
      </div>
    )
}

export default PopUp;